import { create } from 'zustand'

export interface BookingNotification {
  id: string
  guestName: string
  date: string
  time: string
  people: number
  documentId: string
  createdAt: Date
}

interface NotificationStore {
  notifications: BookingNotification[]
  unreadCount: number
  addNotification: (n: Omit<BookingNotification, 'id' | 'createdAt'>) => void
  markAllRead: () => void
  clear: () => void
}

export const useNotificationStore = create<NotificationStore>((set) => ({
  notifications: [],
  unreadCount: 0,

  addNotification: (n) =>
    set((s) => ({
      notifications: [
        { ...n, id: `${Date.now()}-${Math.random()}`, createdAt: new Date() },
        ...s.notifications,
      ].slice(0, 50), // keep last 50
      unreadCount: s.unreadCount + 1,
    })),

  markAllRead: () => set({ unreadCount: 0 }),

  clear: () => set({ notifications: [], unreadCount: 0 }),
}))
